import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  // Monitor reels modal state
  const [isReelsOpen, setIsReelsOpen] = useState(false);
  useEffect(() => {
    const checkReelsState = () => {
      const reelsOpen = document.body?.dataset?.reelsOpen === 'true';
      setIsReelsOpen(reelsOpen);
    };

    checkReelsState();
    const observer = new MutationObserver(checkReelsState);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-reels-open']
    });

    return () => observer.disconnect();
  }, []);

  // Hide footer when reels modal is open
  if (isReelsOpen) {
    return null;
  }

  return (
    <footer className="bg-[#1D3855] text-white py-12 pb-28 lg:pb-12">
      <div className="max-w-7xl mx-auto px-4">
        {/* Logo Section */}
        <div className="flex justify-center mb-6">
          <div className="flex items-center gap-2 filter brightness-0 invert">
            <div>
              <img
                className="w-15 h-10"
                src="/LandLayout.com_PNG.png"
                alt="LandLayout Logo"
              />
            </div>
          </div>
        </div>


        {/* Disclaimer Texts */}
        <div className="mb-4 border-t border-gray-700 pt-6">
          <div className="text-white-300 text-sm leading-relaxed mx-auto">
            <center><strong>{t('footer.disclaimer')}</strong></center>
            <br />
            {t('footer.disclaimerText')}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-white-700 pt-4 flex flex-col md:flex-row justify-between items-center">
          {/* Copyright */}
          <div className="text-sm text-white-400 mb-4 md:mb-0">
            © 2025 LandLayout.com All rights reserved
          </div>

          {/* Contact Us Button */}
          <Link
            to="/contact-us"
            className="inline-flex items-center gap-2 rounded-full border border-white/30 bg-white/5 px-5 py-2 text-sm font-semibold text-white transition-all duration-200 hover:bg-white hover:text-brand-blue hover:border-white mb-4 md:mb-0"
          >
            <Mail className="w-4 h-4" />
            Contact Us
          </Link>

          {/* Social Links */}
          <div className="flex items-center gap-4 mb-4 md:mb-0">
            <a
              href="https://www.instagram.com/landlayout/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white-400 hover:text-white transition-colors text-sm"
            >
              Instagram
            </a>
            <span className="text-white-600 text-sm">•</span>
            <a
              href="https://x.com/landlayout"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white-400 hover:text-white transition-colors text-sm"
            >
              Twitter
            </a>
            <span className="text-white-600 text-sm">•</span>
            <a
              href="https://www.facebook.com/landlayout.official/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white-400 hover:text-white transition-colors text-sm"
            >
              Facebook
            </a>
            <span className="text-white-600 text-sm">•</span>
            <a
              href="https://www.youtube.com/@landlayout"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white-400 hover:text-white transition-colors text-sm"
            >
              YouTube
            </a>
            <span className="text-white-600 text-sm">•</span>
            <a
              href="https://www.linkedin.com/company/landlayout/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white-400 hover:text-white transition-colors text-sm"
            >
              LinkedIn
            </a>
          </div>

          {/* Legal Links */}
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="text-white-400 hover:text-white transition-colors text-sm"
            >
              Terms & Condition
            </a>
            <a
              href="#"
              className="text-white-400 hover:text-white transition-colors text-sm"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
